
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
  } from '@chakra-ui/react'
  import BookingDataService from "../../services/Booking";
export const DeleteBookingModal = ({isOpen,onClose, id, func}:any) => {
  const deleteAssessments = () => {
    BookingDataService.deleteBooking(id)
      .then((response: any) => {
        func(true);
       onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Booking</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          Are you sure you want to delete booking?
          </ModalBody>

          <ModalFooter>
          <Button  bgColor='#327171' color={"white"} mr={3} onClick={deleteAssessments} >Delete</Button>
            <Button  bgColor='red' color={"white"} mr={3} onClick={onClose}>
              No
            </Button>
           
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}
